import dayjs from 'dayjs'
import { getRoomTypesApi } from '@/api/priceSign'
// 横屏竖屏可选择背景
const defaultBgImageKeys = ['blue', 'orange', 'gray', 'black']
export default {
  /**
   * 获取酒店房型信息
   */
  async getRoomTypes(hotelId) {
    const useRoomTypes = []
    const data = await getRoomTypesApi(hotelId)
    if (data.code !== 0) {
      return useRoomTypes
    }
    // 原始房型列表
    const originRoomTypes = data.data
    for (let index = 0; index < originRoomTypes.length; index++) {
      const item = originRoomTypes[index]
      const useRoomType = this.getUseRoomTypeInfo(item)
      if (useRoomType != null) {
        useRoomTypes.push(useRoomType)
      }
    }
    return useRoomTypes
  },

  /**
   * 获取使用的房型信息
   */
  getUseRoomTypeInfo(roomType) {
    const roomTypeTodayInfo = roomType.prices[0]
    if (roomTypeTodayInfo.totalRoomCount <= 0) {
      return null
    }
    const newRoomType = {}
    newRoomType.id = roomType.id
    newRoomType.roomTypeName = roomType.roomTypeName
    newRoomType.price = roomTypeTodayInfo.price
    newRoomType.full = roomTypeTodayInfo.currentRoomCount === 0
    newRoomType.cover = roomType.imgNames ? roomType.imgNames.split('|')[0] : ''
    return newRoomType
  },

  /**
   * 初始化配置信息
   */
  getShowInfo(originConfigInfo, roomTypes, roomTypesDiscount, memberLevels) {
    // 背景图
    this.initBackgroundImageInfo(originConfigInfo)
    // （0：系统价，1：会员最低价，2：0级会员，3：1级会员，4：2级会员，5：3级会员，6：4级会员，7：5级会员）
    const priceTypes = originConfigInfo.showPrice.split(',')
    // 获取显示的价格类型名
    const priceTypeNames = this.getPriceTypeNames(priceTypes, memberLevels)
    // 房型显示的价格
    this.initRoomTypePrices(roomTypes, roomTypesDiscount, priceTypes)
    // 每页显示几个房型 默认6个
    const pageShowCount = originConfigInfo.displayRows
    const roomTypePages = Array.from(
      { length: Math.ceil(roomTypes.length / pageShowCount) },
      (v, i) =>
        roomTypes.slice(i * pageShowCount, i * pageShowCount + pageShowCount)
    )
    return {
      priceTypeNames,
      roomTypePages,
      configInfo: originConfigInfo
    }
  },

  /**
   * 背景图
   */
  initBackgroundImageInfo(config) {
    // 判断原来配置的是默认图片还是自定义
    if (defaultBgImageKeys.includes(config.backgroundImageUrl)) {
      config.bgImageKey = config.backgroundImageUrl
      return
    }
    config.bgImageKey = 'custom'
  },

  /**
   * 获取透明度
   */
  getTransparency(value) {
    const decimal = 255
    const hexadecimal = Math.floor((decimal * (100 - value)) / 100).toString(16)
    return hexadecimal
  },

  /**
   * 获取显示的价格名
   */
  getPriceTypeNames(priceTypes, memberLevels) {
    const priceTypeNames = []
    priceTypes.forEach((priceType) => {
      priceTypeNames.push(
        this.getPriceTypeName(parseInt(priceType), memberLevels)
      )
    })
    return priceTypeNames
  },

  /**
   * 获取价格名
   */
  getPriceTypeName(priceType, memberLevels) {
    // 门市价
    if (priceType === 0) {
      return '门市价'
    }
    // 最低价返回会员最高等级的折扣
    if (priceType === 1) {
      return '最低价'
    }
    // 其余都是会员级别
    const levelIndex = priceType - 2

    // 如果配置了的级别关闭了，那么返回-1不显示
    if (levelIndex > memberLevels.length - 1) {
      return null
    }
    const memberLevel = memberLevels[levelIndex]
    return memberLevel.levelName
  },

  /**
   *
   * @param {价格类型} priceType
   * @param {会员级别信息} memberLevels
   * @returns 房型使用的价格配置
   */
  getRoomTypeDiscountInfo(priceType, memberLevels) {
    // 门市价
    if (priceType === 0) {
      return {
        discountType: 0,
        discount: 1,
        name: '门市价'
      }
    }
    // 最低价需要使用的时候去计算
    if (priceType === 1) {
      return {
        discountType: -1,
        name: '最低价'
      }
    }
    // 其余都是会员级别
    const levelIndex = priceType - 2
    // 如果配置了的级别关闭了，那么返回-1不显示
    if (levelIndex > memberLevels.length - 1) {
      return null
    }
    const memberLevel = memberLevels[levelIndex]
    return {
      discountType: memberLevel.discountType,
      discount: memberLevel.discount,
      name: memberLevel.levelName
    }
  },

  /**
   *
   * @param {原价} originPrice
   * @param {价格类型} priceType
   * @param {全部折扣信息} roomTypeDiscounts
   * 根据价格类型获取价格
   */
  getPriceWithPriceType(originPrice, priceType, roomTypeDiscounts) {
    const discountInfo = this.getRoomTypeDiscountInfo(
      priceType,
      roomTypeDiscounts
    )
    // todo discountInfo为 null 有没有可能？如果有如何处理？
    // 最低价处理
    if (discountInfo.discountType === -1) {
      return this.getRoomTypeLowestPrice(originPrice, roomTypeDiscounts)
    }
    return this.getRoomTypeDiscountPrice(originPrice, discountInfo)
  },

  /**
   * 获取房型的折扣价
   * @param {原价} originPrice
   * @param {折扣信息} disCountInfo
   */
  getRoomTypeDiscountPrice(originPrice, disCountInfo) {
    return disCountInfo.discountType === 0
      ? Math.floor(originPrice * disCountInfo.discount)
      : Math.floor(originPrice + disCountInfo.discount)
  },

  /**
   * 获取房型最低价
   */
  getRoomTypeLowestPrice(originPrice, roomTypeDiscounts) {
    let lowestPrice = originPrice
    for (let index = 0; index < roomTypeDiscounts.length; index++) {
      const item = roomTypeDiscounts[index]
      // 折扣价
      const discountPrice = this.getRoomTypeDiscountPrice(originPrice, item)
      if (discountPrice < lowestPrice) {
        lowestPrice = discountPrice
      }
    }
    return lowestPrice
  },

  /**
   * 获取房型显示的价格
   * 显示的价格类型
   * 房型列表
   * 价格列表
   */
  initRoomTypePrices(roomTypes, hotelRoomTypesDiscount, priceTypes) {
    for (let index = 0; index < roomTypes.length; index++) {
      const roomType = roomTypes[index]
      // 房型所有价格
      const prices = []
      roomType.prices = prices
      priceTypes.forEach((priceType) => {
        prices.push(
          this.getPriceWithPriceType(
            roomType.price,
            parseInt(priceType),
            hotelRoomTypesDiscount[roomType.id]
          )
        )
      })
    }
  },

  /**
   * 当前时间
   */
  getCurrentTime() {
    const date = new Date().getTime()
    const day = dayjs(date).format('MM月DD日')
    const time = dayjs(date).format('HH:mm')
    let dayOfWeek
    const num = dayjs(date).day()
    switch (num) {
      case 0:
        dayOfWeek = '星期天'
        break
      case 1:
        dayOfWeek = '星期一'
        break
      case 2:
        dayOfWeek = '星期二'
        break
      case 3:
        dayOfWeek = '星期三'
        break
      case 4:
        dayOfWeek = '星期四'
        break
      case 5:
        dayOfWeek = '星期五'
        break
      case 6:
        dayOfWeek = '星期六'
        break
    }
    return { day, dayOfWeek, time }
  }
}
